import * as React from "react";
import {cn} from "../lib/utils";

const Input = React.forwardRef<
  React.ElementRef<"input">,
  React.ComponentPropsWithoutRef<"input">
>(({className, ...props}, ref) => (
  <input
    ref={ref}
    className={cn(
      "peer rounded-md border border-green-900/30 ring-offset-white focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-slate-950 focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50",
      "hover:border-green-900/50 hover:bg-green-500/10",
      "p-2 m-2", // padding and margin
      className
    )}
    {...props}
  />
));
Input.displayName = "Input";

export {Input};
